export default "__VITE_ASSET__CRr9vzZx__"